// extracted by mini-css-extract-plugin
module.exports = {"title":"partnerListInner_title__sWXny","subtitle":"partnerListInner_subtitle__kHYFI","listsWrapper":"partnerListInner_listsWrapper__w8SqR","hide":"partnerListInner_hide__j_PMw"};